<template>
  <ContactPage />
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import ContactPage from '@/components/Contact.vue'

export default {
  name: 'Contact',
  components: {
    // HelloWorld
    ContactPage
  }
}
</script>
